export const INTRO1 = `Hi, I'm Adam. Welcome to my portfolio page. 
                      Please check my work below and feel free to contact me if interested.`;

export const INTRO2 = `きゅうです。私のページに来ていただいてありがとう。個人作品は以下の通りになります。どうぞごゆっくり。もし興味があったら、いつでも連絡してください。`;

export const BIO_1 = `曾於行銷產業擔任廣告企劃、數據分析及專案管理。`;

export const BIO_2 = `2年軟體開發經驗，享受拆解問題的過程，在開發工作中，最快樂的時候是碰到有挑戰性的課題時。`;

export const BIO_JAP_1 = `マーケティング業界では、広告企画、データ分析、およびプロジェクト管理の経験がありました。`;

export const BIO_JAP_2 = `2年間のソフトウェア開発経験があり、問題を解析するプロセスを楽しんでいます。開発作業中で最も幸せな瞬間は、挑戦的な課題に出会ったときです。`;

export const SELF_INTRODUCTION_1 = `2019-2021: 
任職於日本廣告公司--博報堂，負責企劃、專案管理，工作範疇包含廣告內容的提案、執行和媒體規劃，以及後續的成效數據分析，專案的進度追蹤和管理。`;
export const SELF_INTRODUCTION_2 = `2022-2023: 
任職於半導體通路公司--大聯大投資控股，前端使用TypeScript、框架為React及Angular。後端使用Java，框架為Spring Boot，CICD和雲服務使用Azure。`;

export const SELF_INTRODUCTION_3 = `工作之餘持續學習新技術、加深對計算機和modern架構的認識，學累了會頻繁檢視自己寫過的code嘗試優化。`;

export const SELF_INTRODUCTION_4 = `短期目標:
熟練socket的運用和分布式架構，精進計算機網路和linux的關聯知識。`;
